


import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Home from "./pages/Home/Home";
import "./i18n/i18n";
import { useTranslation } from "react-i18next";
import Service from "./components/Service";
import Reservation from "./components/Reservation";
import AboutUs from "./components/AboutUs";
import Slider from "./components/Slider";
import Step from "./components/Step";
import Evenement from "./components/Evenement";
import Avis from "./components/Avis";
import ContactezNous from "./components/ContactezNous";
import Footer from "./components/Footer";
import Apartments from "./components/Apartments";
import Villa from "./components/Villa"; // ✅ Must be exactly "Villa"
import Riad from "./components/Riad";
import WhasAppButton from "./components/WhasAppButton"; // Ensure this import exists

import "./styles/Loading.css"; // Add CSS for the loading screen

const App = () => {
  const { i18n } = useTranslation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if the current language is Arabic
    if (i18n.language === "ar") {
      document.documentElement.setAttribute("dir", "rtl");
    } else {
      document.documentElement.setAttribute("dir", "ltr");
    }

    // Simulate API Data Fetching
    const fetchData = async () => {
      try {
        await Promise.all([
          fetch("https://your-api.com/home"),
          fetch("https://your-api.com/apartments"),
          fetch("https://your-api.com/Villa"),
          fetch("https://your-api.com/Riad"),
          fetch("https://your-api.com/services"),
          fetch("https://your-api.com/events"),
        ]);
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setTimeout(() => {
          setLoading(false); // Hide loader after data loads
        }, 1000); // Adding delay for smooth UI transition
      }
    };

    fetchData();
  }, [i18n.language]);

  // Display Loading Screen Until Data is Fully Loaded
  if (loading) {
    return (
      <div className="loading-container ">
        <div className="loading-spinner"></div>
        {/* <p className="loading-text">Loading...</p> */}
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <section id="home">
        <Home />
      </section>
      <section id="Apartment">
        <Apartments />
      </section>
      <section id="Villa">
      <Villa/>
      </section>
      <section id="Riad">
      <Riad />
      </section>
      <section id="about">
        <Service />
      </section>
      <section id="vipContact">
        <Reservation />
      </section>
      <section id="extra">
        <AboutUs />
      </section>
      <section id="experiences">
        <Slider />
      </section>
      <Step />
      <Evenement />
      <Avis />
      <ContactezNous />
     < WhasAppButton />
      <Footer />
    </div>
  );
};

export default App;

